
export default {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_RECEIVE: 'LOGIN_RECEIVE',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN_INITIAL: 'LOGIN_INITIAL',
}

